var normalizeInput = function (container) {
    $(container).keyup(function () {
        var str = $(this).val() + '';
        str = digitsArToEn(digitsFaToEn(toPersianChars(str)));
        $(this).val(str);
    });
    $(container).focusout(function () {
        var str = $(this).val() + '';
        str = digitsArToEn(digitsFaToEn(toPersianChars(str)));
        $(this).val(str);
    });
};

jQuery(document).ready(function($){
    normalizeInput('.normal-text');
});